export const FilesDescription = {
  Reference: 'initial:reference:portrait:with_background:classic',
  Reference_Backup: 'initial:reference:portrait:with_background:backup',

  Formal_With_Accreditation_With_Background: 'initial:formal:with_accreditation:with_background:classic',
  Formal_With_Accreditation_With_Background_Backup: 'initial:formal:with_accreditation:with_background:backup',

  Formal_With_Background: 'initial:formal:portrait:with_background:classic',
  Formal_With_Background_Backup: 'initial:formal:portrait:with_background:backup',

  Informal_With_Background: 'initial:informal:portrait:with_background:classic',
  Informal_With_Background_Backup: 'initial:informal:portrait:with_background:backup',

  Athlete_Saying_Name: 'initial:athlete_saying_name:unused:with_background:classic',
  Athlete_Saying_Name_Backup: 'initial:athlete_saying_name:unused:with_background:backup',

  Empty_Audio: 'initial:empty_audio:unused:with_background:classic',
  Empty_Audio_Backup: 'initial:empty_audio:unused:with_background:backup',

  Formal_Without_Background: 'generated:formal:temporary:without_background:classic',
  Formal_Without_Background_Backup: 'generated:formal:temporary:without_background:backup',

  Informal_Without_Background: 'generated:informal:temporary:without_background:classic',
  Informal_Without_Background_Backup: 'generated:informal:temporary:without_background:backup',

  Formal_Portrait_With_Background: 'generated:formal:portrait:white_background:classic',
  Formal_Portrait_With_Background_Backup: 'generated:formal:portrait:white_background:backup',

  Formal_Portrait_Without_Background: 'generated:formal:portrait:without_background:classic',
  Formal_Portrait_Without_Background_Backup: 'generated:formal:portrait:without_background:backup',

  Formal_Square_Full_With_Background: 'generated:formal:square_full:white_background:classic',
  Formal_Square_Full_With_Background_Backup: 'generated:formal:square_full:white_background:backup',

  Formal_Square_Full_Without_Background: 'generated:formal:square_full:without_background:classic',
  Formal_Square_Full_Without_Background_Backup: 'generated:formal:square_full:without_background:backup',

  Formal_Square_Cropped_With_Background: 'generated:formal:square_cropped:white_background:classic',
  Formal_Square_Cropped_With_Background_Backup: 'generated:formal:square_cropped:white_background:backup',

  formal_Square_Cropped_Without_Background: 'generated:formal:square_cropped:without_background:classic',
  formal_Square_Cropped_Without_Background_Backup: 'generated:formal:square_cropped:without_background:backup',

  Formal_Socials_With_Background: 'generated:formal:socials:with_background:classic',
  Formal_Socials_With_Background_Backup: 'generated:formal:socials:with_background:backup',

  Informal_Socials_With_Background: 'generated:informal:socials:with_background:classic',
  Informal_Socials_With_Background_Backup: 'generated:informal:socials:with_background:backup',

  Informal_SPP_Without_Background: 'generated:informal:spp:without_background:classic',
  Informal_SPP_Without_Background_Backup: 'generated:informal:spp:without_background:backup',

  Formal_SPP_Without_Background: 'generated:formal:spp:without_background:classic',
  Formal_SPP_Without_Background_Backup: 'generated:formal:spp:without_background:backup',

  Thumbnail: 'generated:thumbnail::::',
};
